<template>
	<div class="marketingManagement-body">
		<div class="fx-header">
			<p>组合买赠</p>
		</div>
		<Search @getTableData="getTableDataHandle" :isMuti='isMuti' @getParamsData="getParamsData"></Search>
		<div class="btn-box1">
			<el-button
				type="primary"
				class="search-btn fx-big-btn"
				size="small "
				v-if="AuthorityList['08_0002_0003_00'] || AuthorityList['08_0008_0003_00']"
				@click="addClick"
				icon="el-icon-plus"
				>新增活动
			</el-button>
			<el-button
				type="primary"
				class="search-btn fx-big-btn"
				size="small "
				v-if="AuthorityList['08_0002_0004_00'] || AuthorityList['08_0008_0004_00']"
				@click="delClick(true)"
				plain>删除
			</el-button>
			<el-button
				type="primary"
				class="search-btn fx-big-btn"
				size="small"
				v-if="AuthorityList['08_0002_0005_00'] || AuthorityList['08_0008_0005_00']"
				@click="statusClick(true)"
				plain>停用
			</el-button>
        </div>
		<div class="main-table-box">
			<el-table
			:stripe='true'
			size='mini'
			class="grid-content"
			@row-dblclick='rowClick'
			:data="tableData"
			:height="tableHeight"
			border
			ref="table"
			@select="handleSelectionChange"
			@select-all="handleSelectionChange">
			<el-table-column
			type="selection"
			align="center"
			fixed="left"
			width="50">
			</el-table-column>
			<el-table-column
				label-class-name = "column-index"
				label="序号"
				type="index"
				width="50"
				align="center">
			</el-table-column>
			<el-table-column
				prop="code"
				key="code"
				label="活动名称/活动编号"
				align="center"
				min-width="200">
				<template slot-scope='scope'>
					<div>{{scope.row.name}}</div>
					<div>{{scope.row.code}}</div>
				</template>
			</el-table-column>
			<el-table-column
				key="mainProductName"
				label="活动规则"
				align="center"
				min-width="200">
				<template slot-scope='scope'>
					<div class="rule-box">买：{{scope.row.mainProductName}}{{scope.row.productvariety === 1 ? '（每种均买）' : ''}}</div>
					<div class="rule-box">赠：{{scope.row.giftProducts}}</div>
					<div class="rule-box">赠送方式：
						<span v-if="scope.row.discountrule === 0">仅赠送1次</span>
						<span v-if="scope.row.discountrule === 1">每满足则赠送</span>
						<span v-if="scope.row.discountrule === 2">阶梯赠送</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="beginDate"
				key="beginDate"
				label="活动时间"
				align="center"
				min-width="250">
				<template slot-scope='scope'>
					<div v-if="scope.row.discountdatetype === 0">不限</div>
					<div v-else>
						<span>{{scope.row.beginDate}}-</span>
						<span>{{scope.row.endDate}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column
				label="适用门店"
				align="center"
				min-width="150">
				<template slot-scope="scope">
					<div style="color: var(--fx-primary-color);" v-if="scope.row.shopattendway === 0">全部门店</div>
					<el-tooltip v-else class="item" effect="dark" :content="scope.row.shopnames" placement="top">
						<div style="color: var(--fx-primary-color);">{{scope.row.shopcnt}}家</div>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column
				key="disabledFlag"
				prop="disabledFlag"
				label="启用状态"
				align="center"
				min-width="120">
				<template slot-scope="scope">
					<el-switch size='mini' :disabled="!AuthorityList['08_0002_0005_00'] && !AuthorityList['08_0008_0005_00']" @change="disabledFlagChange(scope.row)" v-model="scope.row.disabledFlag" active-color="#E9EAEB" inactive-color="var(--fx-primary-color)">
					</el-switch>
					<span style="margin-left:10px">{{scope.row.disabledFlag ? '停用' : '启用'}}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="discountstate"
				key="discountstate"
				label="使用状态"
				align="center"
				min-width="90">
				<template slot-scope='scope'>
					<div class="point-box" v-if='scope.row.discountstate === 0'>
						<div class='point' style="background-color:#ED4F31"></div>未生效
					</div>
					<div class="point-box" v-if='scope.row.discountstate === 1'>
						<div class='point' style="background-color:#60C769"></div>已生效
					</div>
					<div class="point-box" v-if='scope.row.discountstate === 2'>
						<div class='point' style="background-color:#CED1D4"></div>已失效
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" min-width="200" align="center">
				<template slot-scope="scope">
					<el-button  type='text' size="mini" icon="el-icon-search" v-if="AuthorityList['08_0002_0002_00'] || AuthorityList['08_0008_0002_00']" @click='modifyClick(scope.row)'>编辑</el-button>
					<el-button  type='text' size="mini" icon="el-icon-search" v-if="AuthorityList['08_0002_0004_00'] || AuthorityList['08_0008_0004_00']" @click='delClick(false,scope.row.id)'>删除</el-button>
				</template>
			</el-table-column>
			</el-table>
		</div>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.number"
            :page-sizes="[20, 40, 60, 100, 300]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
		<el-dialog
			title="提示"
			class="dialog-title"
			:visible.sync="showError"
			width="30%">
			<div style="width: 100%;max-height: 300px;overflow-y:auto ;">
				<div style="padding: 5px 10px;text-align: left;" v-for="(item,index) in errorList" :key='index'>
					【{{item.customername}}】在【{{item.name}}】的买赠活动中已绑定关系！
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" size="mini" @click="showError = false">确 定</el-button>
			</span>
		</el-dialog>
    </div>
</template>
<script>
import Search from '@/components/marketingManagement/Search.vue'
export default {
	name: 'marketingManagement',
	components: {
		Search
	},
	data () {
		return {
			AuthorityList: {
				'08_0002_0001_00': false,
				'08_0002_0002_00': false,
				'08_0002_0003_00': false,
				'08_0002_0004_00': false,
				'08_0008_0001_00': false,
				'08_0008_0002_00': false,
				'08_0008_0003_00': false,
				'08_0008_0004_00': false
			},
			name: '',
			productName: '',
			dateValue: [],
			discountState: -1,
			disabledFlag: -1,
			tableData: [],
			tableHeight: '100%',
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			// ids: [],
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id'
			}),
			isMuti: false,
			showError: false,
			errorList: []
		}
	},
	created () {
		this.init()
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		init () {
			this.isMuti = window.location.hash.split('/')[window.location.hash.split('/').length - 1] === 'mutimarketingManagement'
			this.tableReload()
			if (this.isMuti) {
				this.getAuthority('08_0008_0000_00')
			} else {
				this.getAuthority('08_0002_0000_00')
			}
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		delClick (flag, id) {
			if (flag) {
				if (this.ids.length === 0) {
					this.$message.error('至少选则一条活动')
					return false
				}
			}
			let list = this.ids.map(item => {
				return item.id
			})
			let params = {
				discountids: flag ? list.join(',') : id,
				type: 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/delete`,
				data: params
			}).then(res => {
				if (!res.result) {
					this.$message.error(res.msg)
				} else {
					this.tableSelectUtils.clear()
					this.$message.success('删除成功！')
					this.tableReload()
				}
			})
		},
		statusClick (flag) {
			if (this.ids.length === 0) {
				this.$message.error('至少选则一条活动')
				return false
			}
			let list = this.ids.map(item => {
				return item.id
			})
			let params = {
				discountids: list.join(','),
				disabledflag: flag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/update/disabledflag`,
				data: params
			}).then(res => {
				if (!res.result) {
					this.$message.error(res.msg)
					this.tableReload()
					return false
				}
				this.$message.success('操作成功！')
				this.tableSelectUtils.clear()
				this.tableReload()
			})
		},
		disabledFlagChange (row) {
			let params = {
				discountids: row.id,
				disabledflag: row.disabledFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/update/disabledflag`,
				data: params
			}).then(res => {
				if (!res.result) {
					if (res.code === 1) {
						this.errorList = []
						this.errorList = res.data
						this.showError = true
					} else {
						this.$message.error(res.msg)
					}
					this.tableReload()
					return false
				}
				this.$message.success('操作成功！')
				this.tableReload()
			})
		},
		addClick () {
			window.sessionStorage.removeItem('marketid')
			if (this.isMuti) {
				this.$router.push('mutigift')
			} else {
				this.$router.push('gift')
			}
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
		},
		rowClick (row, column, event) {
			this.modifyClick(row)
		},
		modifyClick (row) {
			if (row.historyflag) {
				this.$message.error('由于版本更新，买赠活动规则已改变，请删除当前活动新增买赠活动')
				return false
			}
			window.sessionStorage.setItem('marketid', row.id)
			if (this.isMuti) {
				this.$router.push('mutigift')
			} else {
				this.$router.push('gift')
			}
		},
		alertCancel () {
			this.alertModal = false
		},
		getTableDataHandle (data) {
			this.tableData = data.recordList
			this.total = data.recordCount
		},
		getParamsData (data) {
			this.tableSelectUtils.clear()
			this.page.number = data.page
			this.page.size = data.size
			this.name = data.name
			this.productName = data.productName
			this.dateValue = data.dateValue
			this.discountState = data.discountState
			this.disabledFlag = data.disabledFlag
		},

		tableReload () {
			let params = {
				name: this.name,
				productName: this.productName,
				beginDate: this.dateValue[0],
				endDate: this.dateValue[1],
				discountState: this.discountState,
				disabledFlag: this.disabledFlag,
				page: this.page.number,
				size: this.page.size
			}
			if (this.isMuti) {
				params.type = 5
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/list`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
				})
				this.total = res.recordCount
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.marketingManagement-body{
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow-y :auto;
    padding-bottom :50px;
    border-radius :0px 0px 10px 10px;
	.btn-box1{
		text-align :left;
		min-height:60px;
		display :flex;
		align-items :center
	}
	.main-table-box {
		flex: 1
		padding-bottom 10px
		overflow-y: auto;
	}
	.rule-box{
		width:100%;
		text-align:left;
		padding: 0 10px;
		overflow :hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.point{
		width:6px;
		height:6px;
		border-radius:50%;
		margin-right:10px;
	}
	.point-box{
		display :flex;
		align-items:center;
		justify-content :center
	}
}

</style>
<style lang="stylus">
.marketingManagement-body {
	.cell{
		padding :0px !important
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.detail-dialog-title {
		.el-dialog__header {
			display: none
		}
		.el-dialog__title {
			padding-left 10px;
			border: none !important;
		}
	}
	.showPicDialog{
		.el-dialog__header {
			border-bottom:1px solid #eee;
			padding: 20px 0px 10px;
			text-align: left;
		}
	}
	.customerDialog{
		.el-dialog__header {
			margin :0px 20px;
			padding :10px 0px;
			border-bottom:1px solid #eee;
			text-align: left;
		}
		.el-dialog__body{
			padding: 10px 20px 10px 20px;
		}
		.name-input .el-input-group__append{
			background-color:var(--fx-primary-color);
			color:#FFFFFF
		}
	}
	.subordinateDialog{
		.el-dialog__body{
			padding :0px 20px;
		}
		.el-dialog__header {
			display :none
		}
		.blue-line{
			height :20px;
			width: 5px;
			background-color :var(--fx-primary-color);
			margin-right :10px;
		}
		.title{
			font-size:16px;
			justify-content: space-between;
			font-weight: bold;
			display :flex;
			flex-direction :row;
			border-bottom:1px solid #eee;
			padding: 20px 0px 10px;
			text-align: left;
			margin-bottom :5px;
			.close{
				cursor: pointer;
				width: 20px;
				height: 20px;
				display :flex;
				align-items :center;
				justify-content :center;
				color :white;
				border-radius: 50%;
				background-color: #f00;
				line-height: 21px;
				font-weight: bold;
			}
		}
	}
	.alert-dialog{
		.el-dialog__title {
			padding-left 10px;
			border: none !important;
			float : left !important;
		}
		.el-dialog__body{
			padding:20px 20px 20px 20px
		}
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: #FFFFFF !important;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:black !important;
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}


}
</style>
